import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Contract, HistoryEntry, UploadedFile, User } from '../../contracte-programari.interface';
import { BeneficiariService } from '../../../beneficiari/beneficiari.service';
import { AppFilesService } from 'src/app/services/app-files.service';
import { helper } from 'src/environments/helper';
import { FormControl, FormGroup } from '@angular/forms';
import { ContracteProgramariService } from '../../contracte-programari.service';

@Component({
    selector: 'app-istoric',
    templateUrl: './istoric.component.html',
    styleUrls: ['./istoric.component.scss']
})
export class IstoricComponent {
    @Input() contract!: Contract;
    @Input() history: HistoryEntry[] = [];
    @Input() user!: User;
    @Output() isLoading = new EventEmitter<boolean>();

    helper = helper;
    isLoadingOperator = false;
    isLoadingCitizen = false;
    isLoadingAll = false;

    filteredHistory!: HistoryEntry[];
    searchParamsForm!: FormGroup;
    initialFormValue = {
        defaultValue: -1,
    };
    messageFilters = [
        { key: '--Toate--', filters: -1 },
        // { key: 'Către cetățean', filters: { automated: 0, type: [0, 1] } },
        // { key: 'Altă destinație', filters: { automated: 0, type: [4] } },
        { key: 'Intern', filters: { automated: false, type: [2, 3] } },
        { key: 'Automat', filters: { automated: true, type: [] } },
    ];

    initFilterForm() {
        this.searchParamsForm = new FormGroup({
            messageFilter: new FormControl(this.initialFormValue.defaultValue),
        });
    }

    constructor(
        private beneficiariService: BeneficiariService,
        private appFileService: AppFilesService,
        private contracteProgramariService: ContracteProgramariService,
    ) { }

    ngOnInit(): void {
        this.initFilterForm();
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.filterHistoryByType();
    }

    filterHistoryByType() {
        const selectedFilter = this.searchParamsForm?.get('messageFilter')?.value || -1;

        if (selectedFilter === -1) {
            this.filteredHistory = this.history;
        } else if (selectedFilter.automated) {
            this.filteredHistory = this.history.filter(entry => entry.automated);
        } else {
            this.filteredHistory = this.history.filter(entry => selectedFilter.type.includes(entry.type));
        }
    }

    downloadDocument(file: UploadedFile) {
        let fullPath = this.beneficiariService.downloadFileUrl + file.id;
        this.isLoading.emit(true);
        this.appFileService.downloadFile(fullPath)
            .then(() => {
                this.isLoading.emit(false);
            })
            .catch(err => {
                console.error('File download error: ', err);
                this.isLoading.emit(false);
            })
    }

    /*
     Pentru type-uri:
     1: Conv de operator + nota interna
     2: Conv de la cetatean
     3: Conv all
    */

    exportConv(type: number) {
        // Set the appropriate loading flag to true based on the type
        if (type === 1) this.isLoadingOperator = true;
        if (type === 3) this.isLoadingAll = true;

        this.contracteProgramariService.exportHistory(this.contract.id, type).subscribe({
            next: (data: Blob) => {
                const blobUrl = URL.createObjectURL(data);
                window.open(blobUrl, '_blank');
                this.resetLoadingFlags();
            },
            error: (error) => {
                console.error('Error exporting PDF:', error);
                this.resetLoadingFlags();
            }
        });
    }

    resetLoadingFlags() {
        this.isLoadingOperator = false;
        this.isLoadingCitizen = false;
        this.isLoadingAll = false;
    }
}
